import React, { useState } from "react";
import { SectionHeader } from "./SectionHeader";
const PLACEHOLDER = "./img/sponsors/placeholder.svg";

export const Sponsors = ({ data }) => {
  const [active, setActive] = useState(null); // für Mobile/Tap

  if (!data || !Array.isArray(data)) return null;
  const handleImgError = (e) => {
  if (e.currentTarget.src.endsWith(PLACEHOLDER)) return; // bereits Placeholder
    e.currentTarget.src = PLACEHOLDER;
  };
  const handleToggle = (idx) => {
    // mobile/touch toggle
    setActive((prev) => (prev === idx ? null : idx));
  };



  return (
    <section id="sponsors" className="sponsors">
        <SectionHeader />
        <div className="section-title text-center mb-4">
          <h2 className="rules-title">Sponsoren</h2>
        </div>
      <div className="sponsors__grid">

        {data.map((s, i) => {
          const src = s.logo || PLACEHOLDER;
          return (
            <div
              key={i}
              className={`sponsor-card ${active === i ? "is-active" : ""}`}
            >
              <button
                className="sponsor-card__inner"
                onClick={() => handleToggle(i)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleToggle(i)}
                aria-expanded={active === i}
                aria-label={`${s.name} – Details anzeigen`}
              >
                <img
                  src={src}
                  alt={`${s.name} Logo`}
                  loading="lazy"
                  className="sponsor-card__logo"
                  onError={handleImgError}
                />
                <div className="sponsor-card__overlay">
                  <h3 className="sponsor-card__name">{s.name}</h3>
                  {s.address && <p className="sponsor-card__address">{s.address}</p>}
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};